import script from "./MemberLink.vue?vue&type=script&setup=true&lang=js"
export * from "./MemberLink.vue?vue&type=script&setup=true&lang=js"

import "./MemberLink.vue?vue&type=style&index=0&id=48dc9ab8&lang=css"

const __exports__ = script;

export default __exports__